export const DEFUALT_COLUMNS = ['spec_concat', 'card_no', 'defect_no', 'compliance_count', 'raw_findings_rate',
    'total_effort_hours', 'total_labor_cost_max','yield_percentage','mntc_check',  'mntc_check_interval', 'fec', 'wpm_score', 'rank', 'spec_type',
    'mntc_check_package',
    'mntc_check_package_interval','escalated_on', 'comments', 'assigned_to']

export const keyLabelMap = {
    'spec_concat': 'Spec No.',
    'card_no': 'Card No.',
    'defect_no': 'Defect Count',
    'compliance_count': 'Compliance Count',
    'raw_findings_rate': 'Raw Finding Rate',
    'total_effort_hours': 'Total Effort Hours',
    'total_labor_cost_max': 'Approx. life-time labor Cost',
    'yield_percentage': 'Yield %',
    'mntc_check': 'Maintenance Check',
    'mntc_check_interval': 'Maintenance Check Interval',
    'fec': 'FEC',
    'wpm_score': 'Rank Score',
    'rank': 'Rank',
    'spec_type': 'Spec Type',
    'mntc_check_package': 'Maintenance Check Package',
    'mntc_check_package_interval': 'Maintenance Check Package Interval',
    'escalated_on': 'Escalated Month',
    'assigned_to': 'Assigned To',
};

export const checkboxData = [
    { label: 'Select All', value: 'all' },
    { label: 'Spec No.', value: 'spec_concat' },
    { label: 'Card No.', value: 'card_no' },
    { label: 'Defect Count', value: 'defect_no' },
    { label: 'Compliance Count', value: 'compliance_count' },
    { label: 'Raw Finding Rate', value: 'raw_findings_rate' },
    { label: 'Total Effort Hours', value: 'total_effort_hours' },
    { label: 'Approx. life-time labor Cost', value: 'total_labor_cost_max' },
    { label: 'Yield %', value: 'yield_percentage' },
    { label: 'Maintenance Check', value: 'mntc_check' },
    { label: 'Maintenance Check Interval', value: 'mntc_check_interval' },
    { label: 'FEC', value: 'fec' },
    { label: 'Rank Score', value: 'wpm_score' },
    { label: 'Rank', value: 'rank' },
    { label: 'Spec Type', value: 'spec_type' },
    { label: 'Maintenance Check Package', value: 'mntc_check_package' },
    { label: 'Maintenance Check Package Interval', value: 'mntc_check_package_interval' },
    { label: 'Escalated Month', value: 'escalated_on' },
    { label: 'Comments', value: 'comments' },
    { label: 'Assigned To', value: 'assigned_to' },
];
export const REQUIRED_COLUMNS = [
  "spec_type",
  "card_no",
  "rank",
  "status",
  "assigned_to",
  "comments"
];
